import { gql } from "@apollo/client"

export const ContingencyTierOverviewSectionApplylistFragment = gql`
    fragment ContingencyTierOverviewSection_applylist on ApplylistType {
        id
        slug
        name
        acceptedCurrency
    }
`
